<template>
  <v-dialog
    v-model="dialogModel"
    scrollable
    max-width="480"
  >
    <v-card>
      <v-card-title class="headline grey lighten-2 layout justify-space-between align-center py-2">
        <span>Period totals</span>
        <span v-if="agentName" class="subheading font-weight-regular ml-3 period-totals-agent-name">{{ agentName }}</span>
      </v-card-title>
      <v-card-text class="pt-4">
        <st-date-field
          id="credit-period-totals-date-from"
          v-model="dateFrom"
          label="From"
          hide-details
          with-time
          class="mb-3"
          to-date-id="credit-period-totals-date-to"
        />
        <st-date-field
          id="credit-period-totals-date-to"
          v-model="dateTo"
          label="To"
          hide-details
          with-time
          class="mb-3"
          from-date-id="credit-period-totals-date-from"
        />
        <v-btn
          block
          small
          color="primary"
          class="mb-4"
          :loading="totalsLoading"
          :disabled="totalsLoading || !canLoadTotals"
          @click="loadTotals"
        >
          Update totals
        </v-btn>
        <v-alert v-if="totalsError" :value="true" type="error" outline class="mb-3">
          {{ totalsError }}
        </v-alert>
        <div v-if="totals">
          <div v-if="showProfit" :class="['total-row', 'total-row--profit', profitIsNegative ? 'total-row--profit-negative' : '']">
            <v-icon class="total-row__icon">{{ profitIsNegative ? 'fas fa-arrow-down' : 'fas fa-chart-line' }}</v-icon>
            <div>
              <div class="caption total-row__label">Profit</div>
              <div class="headline">{{ formatMoney(totals.profit) }}</div>
            </div>
          </div>
          <div class="total-row total-row--passenger">
            <v-icon class="total-row__icon">fas fa-paper-plane</v-icon>
            <div>
              <div class="caption total-row__label">Passenger credits sold</div>
              <div class="title">{{ formatMoney(totals.passengerCreditsSold) }}</div>
            </div>
          </div>
          <div class="total-row total-row--agent">
            <v-icon class="total-row__icon">fas fa-wallet</v-icon>
            <div>
              <div class="caption total-row__label">Agent credits used</div>
              <div class="title">{{ formatMoney(totals.agentCreditsSold) }}</div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn flat color="warning" @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.period-totals-agent-name {
  min-width: 0;
  max-width: 55%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.total-row {
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 4px;
  border-left: 4px solid;
}

.total-row:last-child {
  margin-bottom: 0;
}

.total-row__icon {
  margin-right: 12px;
}

.total-row__label {
  font-weight: 600;
  letter-spacing: 0.02em;
}

.total-row--profit {
  background: #e8f5e9;
  border-left-color: #4CAF50;
}

.total-row--profit .total-row__icon,
.total-row--profit .headline,
.total-row--profit .total-row__label {
  color: #2e7d32;
}

.total-row--profit-negative {
  background: #fde8e1;
  border-left-color: #f65122;
}

.total-row--profit-negative .total-row__icon,
.total-row--profit-negative .headline,
.total-row--profit-negative .total-row__label {
  color: #c43e18;
}

.total-row--passenger {
  background: #e8eef8;
  border-left-color: #204da2;
}

.total-row--passenger .total-row__icon,
.total-row--passenger .title,
.total-row--passenger .total-row__label {
  color: #204da2;
}

.total-row--agent {
  background: #fff8e1;
  border-left-color: #f9a825;
}

.total-row--agent .total-row__icon,
.total-row--agent .title,
.total-row--agent .total-row__label {
  color: #b28704;
}
</style>

<script>
import src from './src'
export default src
</script>
